import Get, {GetCat} from '../Get';
import { Grid, Space } from '../../Layout';
import { Texts, Button, Media } from '../../Object';
import { SetDate } from '../SetDate.js';
import { SetImg } from '../SetImg.js';
import { replaceTag } from '../replaceTag';
import { useDocumentLoadCompleted } from '../../Hooks';
import { Link } from 'react-router-dom';
import { Scroll } from '../../Animation';

const WorksList = (props) => {
  // Getオプション
  const args = {
    postType: "voice",
    perPage: props.perPage ? props.perPage : 6,
    page: props.page ? props.page : 1,
  };
  let base = tmp_path.temp_uri;

  const catArgs = {
    slug: "voice-cat",
  };

  // post情報の取得
  const posts = Get(args);
  const cats = GetCat(catArgs);

  // 個別のエレメント情報
  const Item = (props) => {
    let post = {
      title: props.post.title.rendered, // タイトル
      id: props.post.id, // post id
      body: replaceTag(props.post.content.rendered),
      img: SetImg(props.post), // サムネイル
      userIcon: props.post.acf["user-icon"]
        ? props.post.acf["user-icon"]
        : base + "/dist/assets/images/common/user-noimage.webp",
      userName: props.post.acf.name,
    };

    let position = props.index % 2 ? "right" : "left";
    // console.log(post.userIcon);
    return (
      <>
        <div className="l-row">
          <Scroll state={position}>
            <img
              className="p-img__post--voice"
              data-state={position}
              src={post.img}
              alt="media"
            />
          </Scroll>
          <Scroll>
            <div
              className="p-box__items--about p-box__items--voice"
              data-state={position}
            >
              <div className="p-box__items--voice__inner">
                <p className="c-text__serif c-text--en c-text--big">”</p>

                <div>
                  <p className="c-text__contact-button">{post.title}</p>
                  <Space size={["24px 0 32px", "24px 0 32px"]}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: props.post.content.rendered,
                      }}
                      className="c-text__normal p-post__wrap--body"
                    ></div>
                  </Space>
                  <div className="p-box__items--voice__user">
                    <img
                      className="p-img__user-icon"
                      src={post.userIcon}
                      alt="profile"
                    />
                    <p className="c-text__bold">{post.userName}</p>
                  </div>
                </div>
              </div>

              <Space size={["24px 0 0 auto", "24px 0 0 auto"]}>
                <div className="p-box__items--voice__cat__wrap">
                  {props.post["voice-cat"].map((cat) => (
                    <Cat cat={cat} />
                  ))}
                </div>
              </Space>
            </div>
          </Scroll>
        </div>
      </>
    );
  };

  const Cat = (props) => {
    if (!cats) return true;
    const category = cats.find((cat) => cat.id == props.cat);
    return (
      <>
        <div className="p-box__items--voice__cat">
          <p className="c-text__min c-text--bold">{category.name}</p>
        </div>
      </>
    );
  };

  const Loading = (props) => {
    return (
      <>
        <p>Loading...</p>
      </>
    );
  };

  let items = [];
  if (posts) {
    // post情報取得後
    items = posts.map((post, key) => {
      return <Item key={key} index={key} post={post} />;
    });
  } else {
    // post情報取得中
    items.push(<Loading></Loading>);
  }

  return (
    // 全体のエレメント
    <>
      <div className="c-grid__list--voice">{items}</div>
    </>
  );
};

export default WorksList;